// Native carousel replacement for Slick (HTML/CSS-first, no jQuery dependency)
(function () {
  function resolveElements(target) {
    if (!target) return [];
    if (typeof target === 'string') {
      return Array.prototype.slice.call(document.querySelectorAll(target));
    }
    if (target instanceof Element) return [target];
    if (target instanceof NodeList || Array.isArray(target)) {
      return Array.prototype.slice.call(target);
    }
    return [];
  }

  var DEFAULTS = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 1500
  };

  function toBool(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    if (typeof value === 'boolean') return value;
    return value === 'true' || value === '1';
  }

  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? fallback : parsed;
  }

  function getOptions(el) {
    var opts = Object.assign({}, DEFAULTS);
    var json = el.getAttribute('data-carousel');
    if (json) {
      try {
        var parsed = JSON.parse(json);
        opts = Object.assign(opts, parsed || {});
      } catch (e) {
        // Ignore invalid JSON, fall back to defaults/attributes.
      }
    }

    opts.infinite = toBool(el.getAttribute('data-infinite'), opts.infinite);
    opts.slidesToShow = toNumber(el.getAttribute('data-slides-to-show'), opts.slidesToShow);
    opts.slidesToScroll = toNumber(el.getAttribute('data-slides-to-scroll'), opts.slidesToScroll);
    opts.arrows = toBool(el.getAttribute('data-arrows'), opts.arrows);
    opts.dots = toBool(el.getAttribute('data-dots'), opts.dots);
    opts.autoplay = toBool(el.getAttribute('data-autoplay'), opts.autoplay);
    opts.autoplaySpeed = toNumber(el.getAttribute('data-autoplay-speed'), opts.autoplaySpeed);

    var gap = el.getAttribute('data-slide-gap');
    if (gap) {
      el.style.setProperty('--slide-gap', gap);
    }

    return opts;
  }

  function applyProps(el, props) {
    if (!props) return;
    if (props.mobileOnly !== undefined) {
      el.setAttribute('data-mobile-only', props.mobileOnly ? 'true' : 'false');
    }
    if (props.mobileMax !== undefined) {
      el.setAttribute('data-mobile-max', String(props.mobileMax));
    }
    if (props.desktopSlidesToShow !== undefined) {
      el.setAttribute('data-desktop-slides-to-show', String(props.desktopSlidesToShow));
    }
    if (props.slideGap !== undefined) {
      el.setAttribute('data-slide-gap', props.slideGap);
    }

    var config = {};
    var keys = [
      'infinite',
      'slidesToShow',
      'slidesToScroll',
      'arrows',
      'dots',
      'autoplay',
      'autoplaySpeed'
    ];
    keys.forEach(function (key) {
      if (props[key] !== undefined) config[key] = props[key];
    });

    if (Object.keys(config).length) {
      el.setAttribute('data-carousel', JSON.stringify(config));
    }
  }

  function buildMarkup(el) {
    el.classList.add('native-carousel');
    var track = el.querySelector('.native-carousel__track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'native-carousel__track';
      while (el.firstChild) {
        if (el.firstChild.nodeType === 1) {
          el.firstChild.classList.add('native-carousel__slide');
        }
        track.appendChild(el.firstChild);
      }
      el.appendChild(track);
    } else {
      Array.prototype.forEach.call(track.children, function (child) {
        child.classList.add('native-carousel__slide');
      });
    }
  }

  function shouldInit(el) {
    var mobileOnly = toBool(el.getAttribute('data-mobile-only'), false);
    if (!mobileOnly) return true;
    var max = toNumber(el.getAttribute('data-mobile-max'), 749);
    var matches = window.matchMedia('(max-width: ' + max + 'px)').matches;
    // console.log('[native-carousel] shouldInit', {
    //   mobileOnly: mobileOnly,
    //   max: max,
    //   matches: matches,
    //   element: el
    // });
    return matches;
  }

  function applyDesktopStatic(el) {
    var mobileOnly = toBool(el.getAttribute('data-mobile-only'), false);
    if (!mobileOnly) return;
    var track = el.querySelector('.native-carousel__track');
    if (!track) return;
    var slides = track.children.length;
    if (!slides) return;
    var desktopCount = toNumber(el.getAttribute('data-desktop-slides-to-show'), slides);
    el.style.setProperty('--slides-to-show', Math.max(1, desktopCount));
    track.style.transition = 'none';
    track.style.transform = 'translateX(0)';
  }

  function destroyCarousel(el) {
    var instance = el.__nativeCarousel;
    if (!instance) return;
    // console.log('[native-carousel] destroy', el);
    instance.destroy();
    el.__nativeCarousel = null;
    el.dataset.nativeCarouselInit = 'false';
  }

  function initCarousel(el) {
    if (el.dataset.nativeCarouselInit === 'true') return;
    el.dataset.nativeCarouselInit = 'true';

    var track = el.querySelector('.native-carousel__track');
    if (!track) {
      // console.log('[native-carousel] missing track', el);
      return;
    }

    var options = getOptions(el);
    var originalSlides = Array.prototype.slice.call(track.children);
    if (!originalSlides.length) {
      // console.log('[native-carousel] no slides', el);
      return;
    }
    // console.log('[native-carousel] init', {
    //   slides: originalSlides.length,
    //   options: options,
    //   element: el
    // });

    el.style.setProperty('--slides-to-show', options.slidesToShow);

    var cloneCount = options.infinite
      ? Math.max(options.slidesToShow, options.slidesToScroll)
      : 0;

    if (cloneCount > 0) {
      var headClones = originalSlides.slice(0, cloneCount).map(function (slide) {
        var clone = slide.cloneNode(true);
        clone.classList.add('native-carousel__clone');
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      });
      var tailClones = originalSlides.slice(-cloneCount).map(function (slide) {
        var clone = slide.cloneNode(true);
        clone.classList.add('native-carousel__clone');
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      });

      tailClones.forEach(function (clone) {
        track.insertBefore(clone, track.firstChild);
      });
      headClones.forEach(function (clone) {
        track.appendChild(clone);
      });
    }

    var totalOriginal = originalSlides.length;
    var currentIndex = cloneCount;
    var step = Math.max(1, options.slidesToScroll);
    var perSlide = 100 / options.slidesToShow;

    function setPosition(instant) {
      track.style.transition = instant ? 'none' : 'transform 350ms ease';
      track.style.transform = 'translateX(' + -currentIndex * perSlide + '%)';
    }

    function normalizeIndex(index) {
      if (!options.infinite) return index;
      var offset = index - cloneCount;
      var normalized = ((offset % totalOriginal) + totalOriginal) % totalOriginal;
      return normalized + cloneCount;
    }

    function maxIndex() {
      if (options.infinite) return currentIndex;
      return Math.max(0, totalOriginal - options.slidesToShow);
    }

    function updateDots() {
      if (!dotsRoot) return;
      var realIndex = options.infinite ? (currentIndex - cloneCount) : currentIndex;
      if (options.infinite) {
        realIndex = ((realIndex % totalOriginal) + totalOriginal) % totalOriginal;
      }
      var dotIndex = Math.floor(realIndex / step);
      dotIndex = Math.max(0, Math.min(dotIndex, dots.length - 1));
      dots.forEach(function (dot, idx) {
        dot.setAttribute('aria-current', idx === dotIndex ? 'true' : 'false');
      });
    }

    function goTo(index, instant) {
      if (!options.infinite) {
        var clamped = Math.max(0, Math.min(index, maxIndex()));
        currentIndex = clamped;
        setPosition(instant);
        updateDots();
        return;
      }
      currentIndex = index;
      setPosition(instant);
      updateDots();
    }

    function next() {
      goTo(currentIndex + step, false);
    }

    function prev() {
      goTo(currentIndex - step, false);
    }

    var dotsRoot = null;
    var dots = [];
    if (options.dots) {
      dotsRoot = el.querySelector('.native-carousel__dots');
      if (!dotsRoot) {
        dotsRoot = document.createElement('div');
        dotsRoot.className = 'native-carousel__dots';
        dotsRoot.dataset.nativeCreated = 'true';
        el.appendChild(dotsRoot);
      }

      var dotCount = options.infinite
        ? Math.ceil(totalOriginal / step)
        : Math.floor((totalOriginal - options.slidesToShow) / step) + 1;

      for (var i = 0; i < dotCount; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'native-carousel__dot';
        dot.dataset.nativeCreated = 'true';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        (function (index) {
          dot.addEventListener('click', function () {
            goTo(cloneCount + index * step, false);
          });
        })(i);
        dotsRoot.appendChild(dot);
        dots.push(dot);
      }
    }

    var prevButton = el.querySelector('.native-carousel__nav--prev');
    var nextButton = el.querySelector('.native-carousel__nav--next');
    if (options.arrows) {
      if (!prevButton) {
        prevButton = document.createElement('button');
        prevButton.type = 'button';
        prevButton.className = 'native-carousel__nav native-carousel__nav--prev';
        prevButton.setAttribute('aria-label', 'Previous slide');
        prevButton.textContent = '‹';
        prevButton.dataset.nativeCreated = 'true';
        el.appendChild(prevButton);
      }
      if (!nextButton) {
        nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = 'native-carousel__nav native-carousel__nav--next';
        nextButton.setAttribute('aria-label', 'Next slide');
        nextButton.textContent = '›';
        nextButton.dataset.nativeCreated = 'true';
        el.appendChild(nextButton);
      }
    }

    var onPrev = function () {
      prev();
    };
    var onNext = function () {
      next();
    };
    if (prevButton) prevButton.addEventListener('click', onPrev);
    if (nextButton) nextButton.addEventListener('click', onNext);

    var onTransitionEnd = function () {
      if (!options.infinite) return;
      var normalized = normalizeIndex(currentIndex);
      if (normalized !== currentIndex) {
        currentIndex = normalized;
        setPosition(true);
      }
    };
    track.addEventListener('transitionend', onTransitionEnd);

    setPosition(true);
    updateDots();

    var autoplayTimer = null;
    function startAutoplay() {
      if (!options.autoplay || autoplayTimer) return;
      autoplayTimer = setInterval(function () {
        next();
      }, Math.max(300, options.autoplaySpeed));
    }

    function stopAutoplay() {
      if (!autoplayTimer) return;
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    var onMouseEnter = function () {
      stopAutoplay();
    };
    var onMouseLeave = function () {
      startAutoplay();
    };
    var onFocusIn = function () {
      stopAutoplay();
    };
    var onFocusOut = function () {
      startAutoplay();
    };
    var onVisibilityChange = function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    };

    if (options.autoplay) {
      startAutoplay();
      el.addEventListener('mouseenter', onMouseEnter);
      el.addEventListener('mouseleave', onMouseLeave);
      el.addEventListener('focusin', onFocusIn);
      el.addEventListener('focusout', onFocusOut);
      document.addEventListener('visibilitychange', onVisibilityChange);
    }

    el.__nativeCarousel = {
      destroy: function () {
        stopAutoplay();
        if (prevButton) prevButton.removeEventListener('click', onPrev);
        if (nextButton) nextButton.removeEventListener('click', onNext);
        track.removeEventListener('transitionend', onTransitionEnd);
        el.removeEventListener('mouseenter', onMouseEnter);
        el.removeEventListener('mouseleave', onMouseLeave);
        el.removeEventListener('focusin', onFocusIn);
        el.removeEventListener('focusout', onFocusOut);
        document.removeEventListener('visibilitychange', onVisibilityChange);

        var clones = track.querySelectorAll('.native-carousel__clone');
        clones.forEach(function (clone) {
          clone.remove();
        });

        var createdDots = el.querySelectorAll('.native-carousel__dot[data-native-created="true"]');
        createdDots.forEach(function (dot) {
          dot.remove();
        });

        var createdArrows = el.querySelectorAll('.native-carousel__nav[data-native-created="true"]');
        createdArrows.forEach(function (arrow) {
          arrow.remove();
        });

        var dotsContainer = el.querySelector('.native-carousel__dots[data-native-created="true"]');
        if (dotsContainer && dotsContainer.children.length === 0) {
          dotsContainer.remove();
        }

        track.style.transition = '';
        track.style.transform = '';
      }
    };
  }

  function initAll() {
    var carousels = document.querySelectorAll('.native-carousel');
    // console.log('[native-carousel] initAll', { count: carousels.length });
    carousels.forEach(function (el) {
      if (shouldInit(el)) {
        initCarousel(el);
      } else {
        destroyCarousel(el);
        applyDesktopStatic(el);
      }
    });
    setupMediaListeners(Array.prototype.slice.call(carousels));
  }

  function getBreakpointSet() {
    return Object.create(null);
  }

  function collectBreakpoints(carousels) {
    var set = getBreakpointSet();
    carousels.forEach(function (el) {
      if (!toBool(el.getAttribute('data-mobile-only'), false)) return;
      var max = toNumber(el.getAttribute('data-mobile-max'), 749);
      set[max] = true;
    });
    return Object.keys(set).map(function (value) {
      return parseInt(value, 10);
    });
  }

  var mediaListeners = Object.create(null);

  function setupMediaListeners(carousels) {
    var breakpoints = collectBreakpoints(carousels);
    // console.log('[native-carousel] setupMediaListeners', { breakpoints: breakpoints });
    breakpoints.forEach(function (bp) {
      if (mediaListeners[bp]) return;
      var media = window.matchMedia('(max-width: ' + bp + 'px)');
      var handler = function () {
        // console.log('[native-carousel] media change', { breakpoint: bp, matches: media.matches });
        initAll();
      };
      if (typeof media.addEventListener === 'function') {
        media.addEventListener('change', handler);
      } else if (typeof media.addListener === 'function') {
        media.addListener(handler);
      }
      mediaListeners[bp] = true;
    });
  }

  function boot() {
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function NativeCarousel(selector, props) {
    this.elements = resolveElements(selector);
    this.props = props || {};
    this.init();
  }

  NativeCarousel.prototype.init = function () {
    var self = this;
    this.elements.forEach(function (el) {
      applyProps(el, self.props);
      buildMarkup(el);
    });
    initAll();
  };

  NativeCarousel.prototype.destroy = function () {
    this.elements.forEach(function (el) {
      destroyCarousel(el);
      applyDesktopStatic(el);
    });
  };

  NativeCarousel.refresh = initAll;

  window.NativeCarousel = NativeCarousel;
})();
